import { gql } from '@apollo/client';

export const QUERY_ONBOARDING_STEP4 = gql`
  query onBoardingStep4 {
    step4 {
      data {
        attributes {
          content {
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
            button {
              text
              link
            }
          }
          roles {
            role
          }
          ageBracket {
            label
            placeholder
            options {
              option
            }
          }
          role {
            label
            placeholder
          }
          gender {
            label
            placeholder
            options {
              option
            }
          }
          location {
            label
            placeholder
          }
        }
      }
    }
  }
`;

export const MUTATION_ONBOARDING_UPDATE_USER_TOPICS = gql`
  mutation updateUserTopics($id: ID!, $topics: [ID]) {
    updateUsersPermissionsUser(id: $id, data: { topics: $topics }) {
      data {
        attributes {
          updatedAt
        }
      }
    }
  }
`;
